// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_hc","advertCardFooter__row":"c-a_he","advertCardFooter__name":"c-a_hf","advertCardFooter__price":"c-a_hg","advertCardFooter__age":"c-a_hh"};